<template>
    <app-layout>
        <QrReader />
    </app-layout>
</template>


<script>
    import AppLayout from '@/Layouts/AppLayout'
    import QrReader from '@/Components/QrReader'

    export default {
        components: {
            AppLayout,
            QrReader
        },
        props: ['user'],
    }
</script>